<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat v-if="toolbar">
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button
            v-if="showSavitarnaCopySkolininkai"
            :loading="savitarnaSkolininkaiLoading"
            @click.native.stop="openSkolininkasSelect()"
          >
            Kopijuoti skolininko duomenis
          </el-button>
          <el-button
            v-if="showSavitarnaCopyIkaitoDavejai"
            :loading="savitarnaSkolininkaiLoading"
            @click.native.stop="openDavejasSelect()"
          >
            Kopijuoti įkaito davėjo duomenis
          </el-button>
          <el-button
            v-if="showSavitarnaCopyKreditoriai"
            :loading="savitarnaSkolininkaiLoading"
            @click.native.stop="openKreditoriusSelect()"
          >
            Kopijuoti kreditorių duomenis
          </el-button>
          <el-button
            v-if="showCopySkolininkai"
            @click.native.stop="copySkolininkai()"
          >
            Kopijuoti skolininko duomenis
          </el-button>
          <el-button-prideti
            v-if="showPridetiAsmeni"
            :primary="pridetiColor"
            @click.native.stop="openAsmuo(null)"
          >
            Pridėti asmenį
          </el-button-prideti>
          <el-button-prideti
            v-if="showPridetiAdresata"
            :primary="pridetiColor"
            @click.native.stop="openInformavimas(null)"
          >
            Pridėti adresatą
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.turtasDavejas`]="{ item }">
        <div class="text-center">
          <el-checkbox
            class="mb-3"
            label=" "
            :key="item.sasm_id"
            v-model="turtasDavejasList"
            :checkValue="item.sasm_id"
            :readonly="readonly || isAdresas"
          />
        </div>
      </template>
      <template #[`item.skolininkasSavininkas`]="{ item }">
        <div class="text-center">
          {{ item.sasm_skolininkas_savininkas ? 'Taip' : '' }}
        </div>
      </template>
      <template #[`item.kreditoriuAtstovas`]="{ item }">
        <div class="text-center">
          {{ item.sasm_kreditorius_atstovas ? 'Taip' : '' }}
        </div>
      </template>
      <template #[`item.vykdomasisKreditorius`]="{ item }">
        <div class="text-center">
          <el-checkbox
            label=" "
            v-model="vykdomasisKreditoriaiList"
            :key="item.sasm_id"
            :checkValue="item.sasm_id"
            :readonly="!(isRengiamas || isGrazintas) || readonly"
          />
        </div>
      </template>
      <template #[`item.asm_asmens_kodas`]="{ item }">
        {{ item.asm_asmens_kodas }}
        <div
          v-if="!!item.foreign_pastaba"
          class="foreign-pastaba"
          v-html="item.foreign_pastaba"
        ></div>
      </template>
      <template #[`item.atpirkimoPageidavimas`]="{ item }">
        <div class="nowrap" v-if="item.sutartisDavejas">
          <v-chip
            :color="item.sasm_atpirkimo_pageidavimas ? 'green' : 'default'"
            small
            outlined
            filter-icon="mdi-plus"
            class="mr-2"
          >
            <v-icon
              left
              small
              color="green"
              v-if="item.sasm_atpirkimo_pageidavimas"
            >
              mdi-check-bold
            </v-icon>
            {{ item.atpirkimoPageidavimas }}
          </v-chip>
          <el-button
            primary
            x-small
            @click.native="changePageidavimas(item)"
            v-if="item.atpirkimoPageidavimasBtn"
          >
            keisti
          </el-button>
        </div>
      </template>
      <template #[`item.sasm_el_pastai`]="{ item }">
        {{ item.sasm_el_pastai.join(', ') }}
      </template>
      <template #[`item.patvirtinimas`]="{ item }">
        <template v-if="item.patvirtinimas_reikia_pasirasyti">
          <v-chip
            v-if="item.patvirtinimas_pasirasyta"
            color="green"
            small
            outlined
            class="mr-2"
          >
            Pasirašyta {{ item.patvirtinimas_data }}
          </v-chip>
          <v-chip
            v-if="!item.patvirtinimas_pasirasyta"
            color="green"
            small
            outlined
            class="mr-2"
          >
            Laukia pasirašymo
          </v-chip>
        </template>
      </template>
      <template #[`item.atstovas`]="{ item }">
        {{ item.atstovas.asm_pavadinimas }}
        <div class="text-gray">
          {{ item.atstovas.veikiantis_pagal }}
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @deleteItem="deleteItem(item)"
          @restoreItem="restoreItem(item)"
          @addAtstovas="addAtstovas(item.atstovas)"
          @editAtstovas="editAtstovas(item.atstovas)"
          @viewAtstovas="editAtstovas(item.atstovas)"
          @deleteAtstovas="deleteAtstovas(item.atstovas)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-asmuo
      :key="modalAsmuoKey"
      v-model="showAsmuo"
      :asmuo="modalAsmuo"
      :asmuo-role="modalAsmuoRole"
      :parent-atstovas-id="modalParentAtstovasId"
      :salys="salys"
      :atstovavimo-pagrindas="atstovavimo_pagrindas"
      :sutartis="isSutartis"
      :readonly="modalAsmuoReadonly"
      :atnaujinti="atnaujintiAsmuo"
      :tik-adresas="isAdresas"
      :ktp="false"
      @savedData="savedAsmuo"
      @savedAtstovas="savedAtstovas"
    />
    <modal-informavimas
      :key="modalInformavimasKey"
      v-model="showInformavimas"
      :item="modalInformavimasItem"
      :readonly="modalInformavimasReadonly"
      @confirmSave="confirmInformavimas"
    />
    <modal-delete
      title="Šalinti asmenį?"
      :text="
        `Ar norite pašalinti asmenį <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-asmuo-select
      v-model="showAsmuoSelect"
      :title="asmuoSelectTitle"
      :asmenys="asmuoSelectList"
      :asmenys-pazymeti="asmuoSelectPazymeti"
      @savedData="updateAsmuoSelect"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import ModalAsmuo from '../modals/ModalAsmuo'
import ModalAsmuoSelect from '../modals/ModalAsmuoSelect'
import ModalInformavimas from '../modals/ModalInformavimas'
import ModalDelete from '../modals/ModalDelete'
import rowClass from '../../mixins/rowClass'
import busena from '../../mixins/busena'
import userRole from '../../mixins/userRole'

export default {
  name: 'HipotekaAsmenys',
  components: {
    ModalAsmuo,
    ModalAsmuoSelect,
    ModalInformavimas,
    ModalDelete,
  },
  props: {
    asmuoRole: String,
    vykdomasisKreditoriai: Array,
    vykdomasisId: { type: Number, default: null },
    turtasDavejas: { type: Array, default: () => [] },
    turtas: { type: Boolean, default: false },
    ntr: { type: Boolean, default: false },
    ktp: { type: Boolean, default: false },
    toolbar: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    noBusimas: { type: Boolean, default: false },
  },
  mixins: [busena, rowClass, userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      savitarnaSkolininkaiLoading: false,
      search: null,
      showAsmuo: false,
      modalAsmuoReadonly: false,
      modalAsmuoKey: 'asmuo',
      modalAsmuoRefresh: 0,
      modalAsmuoRole: null,
      modalParentAtstovasId: null,
      modalAsmuo: {},
      modalSavininkas: false,
      showAsmuoSelect: false,
      asmuoSelectTitle: null,
      asmuoSelectList: [],
      asmuoSelectPazymeti: [],
      salys: [],
      atstovavimo_pagrindas: [],
      modalInformavimasItem: {},
      modalInformavimasReadonly: false,
      modalInformavimasKey: 'informavimas',
      modalInformavimasRefresh: 0,
      showInformavimas: false,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalDeleteRole: null,
      asmenys: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'turtasID',
      'hipotekaBusena',
      'objektasVeiksmas',
      'objektasSavitarna',
      'perduodamasKreditoriui',
      'dokumentasSavitarna',
      'appSavitarna',
    ]),
    headers() {
      return [
        {
          text: 'Aktyvus',
          align: 'center',
          value: 'turtasDavejas',
          hide: !(this.turto_davejas && !this.isSavitarna),
        },
        {
          text: 'Dalis',
          align: 'center',
          value: 'sasm_dalis',
          hide: !this.isKtp,
        },
        {
          text: 'Kreditorius',
          align: 'center',
          value: 'vykdomasisKreditorius',
          hide: !this.isVykdomasisKeditoriai,
        },
        {
          text: 'Skolininkas yra turto savininkas',
          align: 'center',
          value: 'skolininkasSavininkas',
          hide: !this.skolininkas || this.isSavitarna,
        },
        {
          text: 'Rolė',
          align: 'start',
          value: 'sutartis_role',
          hide: !this.isSutartis,
        },
        {
          text: 'Kreditorių atstovas',
          align: 'center',
          value: 'kreditoriuAtstovas',
          hide: !this.kreditorius,
        },
        {
          text: 'Asmens kodas',
          align: 'start',
          value: 'asm_asmens_kodas',
          hide: this.informuojamas,
        },
        {
          text: 'Vardas Pavardė / Pavadinimas',
          align: 'start',
          value: 'asm_pavadinimas',
        },
        {
          text: 'Adresas',
          align: 'start',
          value: 'adr_text',
          hide: this.informuojamas,
        },
        {
          text: 'Atstovas',
          align: 'start',
          value: 'atstovas',
          hide: !this.showAtstovasCell,
        },
        {
          text: 'Asmens dokumentas',
          align: 'start',
          value: 'sasm_fiz_dok_info',
          hide: !this.showAsmensDokumentas,
        },
        {
          text: 'El. pašto adresas',
          align: 'start',
          value: 'sasm_el_pastai',
          hide: !this.informuojamas,
        },
        {
          text: 'Patvirtinimas',
          align: 'start',
          value: 'patvirtinimas',
          hide: !this.showPatvirtinimas,
        },
        {
          text: 'Pageidavimas pasinaudoti atpirkimo teise',
          align: 'start',
          value: 'atpirkimoPageidavimas',
          width: 200,
          hide: !this.showPageidavimasCol,
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map(item => {
        if (this.isSutartis) {
          const key = Object.keys(HipotekaMap['sutartisRolesTekstas']).find(e =>
            this.hipotekaTipas.includes(e)
          )
          item.sutartis_role = key
            ? HipotekaMap['sutartisRolesTekstas'][key][item.sasm_role_objekte]
            : null
          item.sutartisDavejas =
            item.sasm_role_objekte ===
            HipotekaMap['asmenysRoles'].sutartis_davejas

          item.atpirkimoPageidavimas = item.sasm_atpirkimo_pageidavimas
            ? 'pageidauja'
            : 'nepageidauja'
          item.isTevinis = item.sasm_tevinis_id > 0
          item.atpirkimoPageidavimasBtn =
            (this.isRengiamas || this.isGrazintas) &&
            (this.isSutartisPageidavimas ||
              (this.isSutartisAtsaukimas &&
                item.sasm_pageidavimas_iregistravimo_data !== null))
        }

        item.readonly =
          this.readonly || (this.turto_davejas && !item.can_delete)

        if (!item.readonly) {
          item.canEdit = !item.deleted
          item.canDelete = !item.deleted && item.can_delete
          item.canRestore = item.tevinis_id > 0 && (item.deleted || item.edited)
        } else {
          item.canView = true
        }

        if (
          !this.readonly &&
          this.turto_davejas &&
          !item.canDelete &&
          (this.isRengiamas || this.isGrazintas)
        ) {
          item.canEdit = true
          item.canView = false
          item.canDelete = false
          item.readonly = false
        }

        if (this.informuojamas && item.amn_id) {
          item.canDelete = false
        }

        item.atstovas = {}
        if (item.tipas === 'JUR') {
          item.atstovas = {
            parent_atstovas_id: item.sasm_id,
            sasm_id: item.atstovas_sasm_id,
            asm_pavadinimas: item.atstovas_pavadinimas,
            veikiantis_pagal: item.atstovas_veikiantis_pagal
              ? `Veikiantis pagal: ${item.atstovas_veikiantis_pagal}`
              : '',
            sasm_role_objekte: 'atstovas',
            readonly: item.readonly,
          }
          if (item.atstovas_sasm_id) {
            item.sasm_fiz_dok_info = item.atstovas_fiz_dok_info
            item.canViewAtstovas = true
            item.canEditAtstovas = false
            item.canDeleteAtstovas =
              item.canDelete &&
              item.atstovas_galima_salinti &&
              this.showAtstovas &&
              !this.informuojamas
          } else {
            item.canAddAtstovas =
              item.canEdit &&
              item.atstovas_galima_salinti &&
              this.showAtstovas &&
              !this.informuojamas
          }
        }

        if (this.isAdresas) {
          item.readonly = false
          item.canEdit = true
          item.canView = false
          item.canDelete = false
          item.canAddAtstovas = false
          item.canDeleteAtstovas = false
        }

        return item
      })
    },
    aktyvusList() {
      return this.asmenys
        .filter(item => {
          return item.sasm_pazymetas
        })
        .map(item => item.sasm_id)
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSutartis() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].sutartis
    },
    isSutartisPageidavimas() {
      return this.hipotekaTipas.includes('pageidavimas')
    },
    isSutartisAtsaukimas() {
      return this.hipotekaTipas.includes('atsaukimas')
    },
    isSandoris() {
      return this.hipotekaTipas.includes('sandoris')
    },
    isPakeitimas() {
      return this.hipotekaTipas.includes('pakeitimas')
    },
    isVykdomasis() {
      return this.hipotekaTipas.includes('vykdomasis')
    },
    isAdresas() {
      return (
        this.hipotekaTipas.includes('adresas') &&
        (this.isRengiamas || this.isGrazintas)
      )
    },
    showPageidavimasCol() {
      return (
        this.isSutartis &&
        (this.isSutartisPageidavimas || this.isSutartisAtsaukimas)
      )
    },
    asmenysUrl() {
      let url = ''
      if (this.turtas) {
        url = `objektas/${this.objektasID}/turtas/${this.turtasID}/role/${this.asmuoRole}`
      } else {
        url = `asmuo/${this.objektasID}/${this.asmuoRole}`
      }
      return url
    },
    skolininkas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].skolininkas
    },
    kreditorius() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].kreditorius
    },
    turto_davejas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].turtas_davejas
    },
    ikaito_davejas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].davejas
    },
    ikaito_davejas_hr() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].davejasHR
    },
    busimas_savininkas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].busimas_savininkas
    },
    gavejas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].turtas_gavejas
    },
    pridetiColor() {
      return !this.turtas
    },
    informuojamas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].informuojamas
    },
    showAtstovas() {
      return (
        !this.isPabaiga &&
        (!this.isSavitarna ||
          (this.dokumentasSavitarna && this.objektasVeiksmas === 1)) &&
        (this.skolininkas ||
          this.kreditorius ||
          this.turto_davejas ||
          this.ikaito_davejas ||
          this.ikaito_davejas_hr ||
          this.busimas_savininkas ||
          this.gavejas ||
          this.informuojamas)
      )
    },
    showAtstovasCell() {
      return (
        this.showAtstovas &&
        this.asmenys.filter(asmuo => asmuo.atstovas_pavadinimas).length > 0
      )
    },
    isAsmensDokumentas() {
      return this.asmenys.filter(asmuo => asmuo.sasm_fiz_dok_info).length > 0
    },
    showAsmensDokumentas() {
      return (
        !this.informuojamas &&
        this.isAsmensDokumentas &&
        this.objektasVeiksmas === 1
      )
    },
    isVykdomasisKeditoriai() {
      return this.vykdomasisKreditoriai
    },
    vykdomasisKreditoriaiList: {
      set(value) {
        this.$emit('updateVykdomasisKreditoriai', value)
      },
      get() {
        return this.vykdomasisKreditoriai
      },
    },
    turtasDavejasList: {
      set(value) {
        // value = this.withTeiseDalis(value)
        this.$emit('updateTurtasDavejas', value)
      },
      get() {
        return this.turtasDavejas
      },
    },
    isNtr() {
      return this.ntr
    },
    isKtp() {
      return this.ktp
    },
    showCopySkolininkai() {
      return (
        !this.isSavitarna &&
        !this.readonly &&
        this.turto_davejas &&
        !this.isNtr &&
        !this.isVykdomasis &&
        (this.isSandoris || this.isPakeitimas) &&
        !this.isAdresas
      )
    },
    showSavitarnaCopySkolininkai() {
      return (
        this.isSavitarna &&
        !this.readonly &&
        this.ikaito_davejas &&
        (this.isRengiamas || this.isGrazintas) &&
        !this.isAdresas
      )
    },
    showSavitarnaCopyIkaitoDavejai() {
      return (
        this.isSavitarna &&
        !this.readonly &&
        this.turto_davejas &&
        (this.isRengiamas || this.isGrazintas) &&
        !this.isAdresas
      )
    },
    showSavitarnaCopyKreditoriai() {
      return (
        this.isSavitarna &&
        !this.readonly &&
        this.gavejas &&
        this.perduodamasKreditoriui === 1 &&
        (this.isRengiamas || this.isGrazintas) &&
        !this.isAdresas
      )
    },
    showPridetiAsmeni() {
      return (
        !this.readonly &&
        !this.isNtr &&
        !this.informuojamas &&
        !this.showSavitarnaCopyIkaitoDavejai &&
        !this.showSavitarnaCopyKreditoriai &&
        !this.isAdresas &&
        !this.noBusimas
      )
    },
    showPridetiAdresata() {
      return (
        !this.readonly &&
        this.informuojamas &&
        !this.isSavitarna &&
        !this.isAdresas
      )
    },
    isSavitarna() {
      return this.appSavitarna
    },
    atnaujintiAsmuo() {
      return (
        (this.isRengiamas || this.isPerduotas || this.isGrazintas) &&
        (this.skolininkas ||
          this.kreditorius ||
          this.ikaito_davejas ||
          this.turto_davejas ||
          this.gavejas ||
          this.isSutartis)
      )
    },
    showPatvirtinimas() {
      return (
        (this.isSavitarna && this.informuojamas) ||
        (!this.isSavitarna && this.objektasSavitarna && !this.isSutartis)
      )
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(this.asmenysUrl)
        .then(res => {
          this.asmenys = res.data.asmenys
          this.salys = res.data.salys
          this.atstovavimo_pagrindas = res.data.atstovavimo_pagrindas
          if (this.turto_davejas) {
            this.$emit('updateTurtasDavejas', this.aktyvusList)
          }
          if (this.busimas_savininkas) {
            this.$emit('updateBusimasSavininkas', this.asmenys.length)
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    copySkolininkai() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(
          `objektas/${this.objektasID}/turtas/${this.turtasID}/copySkolininkas`
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    openSkolininkasSelect() {
      this.savitarnaSkolininkaiLoading = true
      this.$axios
        .get(`asmuo/${this.objektasID}/skolininkas`)
        .then(res => {
          let skolininkaiAsmenys = res.data.asmenys
          if (skolininkaiAsmenys.length == 0) {
            window._VMA.$emit(
              'DATA_ERROR',
              'Duomenys nebus nukopijuoti, nes neįvestas nei vienas skolininkas.'
            )
            return
          }
          if (skolininkaiAsmenys.length == 1) {
            this.copySavitarnaSkolininkai([skolininkaiAsmenys[0].amn_id])
            return
          }
          this.asmuoSelectList = skolininkaiAsmenys
          this.asmuoSelectPazymeti = this.asmenys.map(item => {
            return item.amn_id
          })
          this.asmuoSelectTitle = 'Skolininkai'
          this.showAsmuoSelect = true
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.savitarnaSkolininkaiLoading = false
        })
    },
    copySavitarnaSkolininkai(pazymetasList) {
      this.savitarnaSkolininkaiLoading = true

      const data = {
        role_from: 'skolininkas',
        role_to: 'davejas',
        pazymetas_list: pazymetasList,
      }
      this.$axios
        .post(`asmuo/${this.objektasID}/copyasmuo`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.savitarnaSkolininkaiLoading = false
        })
    },
    openDavejasSelect() {
      this.savitarnaSkolininkaiLoading = true
      this.$axios
        .get(`asmuo/${this.objektasID}/davejas`)
        .then(res => {
          let skolininkaiAsmenys = res.data.asmenys
          if (skolininkaiAsmenys.length == 0) {
            window._VMA.$emit(
              'DATA_ERROR',
              'Duomenys nebus nukopijuoti, nes neįvestas nei vienas įkaito davėjas.'
            )
            return
          }
          if (skolininkaiAsmenys.length == 1) {
            this.copySavitarnaDavejai([skolininkaiAsmenys[0].amn_id])
            return
          }
          this.asmuoSelectList = skolininkaiAsmenys
          this.asmuoSelectPazymeti = this.asmenys.map(item => {
            return item.amn_id
          })
          this.asmuoSelectTitle = 'Įkaito davėjai'
          this.showAsmuoSelect = true
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.savitarnaSkolininkaiLoading = false
        })
    },
    openKreditoriusSelect() {
      this.savitarnaSkolininkaiLoading = true
      this.$axios
        .get(`asmuo/${this.objektasID}/kreditorius`)
        .then(res => {
          let skolininkaiAsmenys = res.data.asmenys
          if (skolininkaiAsmenys.length == 0) {
            window._VMA.$emit(
              'DATA_ERROR',
              'Duomenys nebus nukopijuoti, nes neįvestas nei vienas kreditorius.'
            )
            return
          }
          if (skolininkaiAsmenys.length == 1) {
            this.copySavitarnaKreditoriai([skolininkaiAsmenys[0].amn_id])
            return
          }
          this.asmuoSelectList = skolininkaiAsmenys
          this.asmuoSelectPazymeti = this.asmenys.map(item => {
            return item.amn_id
          })
          this.asmuoSelectTitle = 'Kreditoriai'
          this.showAsmuoSelect = true
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.savitarnaSkolininkaiLoading = false
        })
    },
    copySavitarnaDavejai(pazymetasList) {
      this.savitarnaSkolininkaiLoading = true

      const data = {
        role_from: 'davejas',
        role_to: 'turto_davejas',
        pazymetas_list: pazymetasList,
      }
      this.$axios
        .post(
          `objektas/${this.objektasID}/turtas/${this.turtasID}/copyDavejas`,
          data
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.savitarnaSkolininkaiLoading = false
        })
    },
    copySavitarnaKreditoriai(pazymetasList) {
      this.savitarnaSkolininkaiLoading = true

      const data = {
        role_from: 'kreditorius',
        role_to: 'turto_gavejas',
        pazymetas_list: pazymetasList,
      }
      this.$axios
        .post(
          `objektas/${this.objektasID}/turtas/${this.turtasID}/copyKreditorius`,
          data
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.savitarnaSkolininkaiLoading = false
        })
    },
    editItem(item) {
      if (this.informuojamas) {
        this.openInformavimas(item)
      } else {
        this.openAsmuo(item.sasm_id, item.readonly)
      }
    },
    openAsmuo(sasm_id, readonly = false) {
      this.modalAsmuo = {
        sasm_id: sasm_id,
      }
      this.modalAsmuoReadonly = readonly
      this.modalAsmuoRole = this.asmuoRole
      this.modalParentAtstovasId = null
      this.modalAsmuoKey =
        'asmuo' + (sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    savedAsmuo(modalAsmuo, atstovas = false) {
      this.loading = true

      let data = modalAsmuo
      data.obj_id = this.objektasID
      data.tur_id = this.turtas ? this.turtasID : null
      data.vyk_id = this.vykdomasisId

      data.sasm_role_objekte = this.isSutartis
        ? modalAsmuo.sasm_role_objekte
        : this.asmuoRole

      if (atstovas) {
        data.sasm_role_objekte = 'atstovas'
      }

      this.$axios
        .post(`asmuo`, data)
        .then(res => {
          this.modalAsmuoKey = 'asmuo'
          window._VMA.$emit('DATA_OK', res.data.message)
          this.showAsmuo = false
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addAtstovas(item) {
      this.openAtstovas(null, item.parent_atstovas_id)
    },
    editAtstovas(item) {
      this.openAtstovas(item.sasm_id, item.parent_atstovas_id, item.readonly)
    },
    openAtstovas(sasm_id, parent_atstovas_id, readonly = false) {
      this.modalAsmuo = {
        sasm_id: sasm_id,
      }
      this.modalAsmuoReadonly = readonly
      this.modalAsmuoRole = 'atstovas'
      this.modalParentAtstovasId = parent_atstovas_id
      this.modalAsmuoKey =
        'asmuo' + (sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    savedAtstovas(modalAsmuo) {
      this.loading = true

      modalAsmuo.sasm_atstovaujamas_id = modalAsmuo.parent_atstovas_id
      this.savedAsmuo(modalAsmuo, true)
      // const data = {
      //   sasm_id: modalAsmuo.parent_atstovas_id,
      //   amn_id: modalAsmuo.amn_id,
      // }

      // this.$axios
      //   .post(`asmuo/${modalAsmuo.parent_atstovas_id}/atstovas`, data)
      //   .then(res => {
      //     window._VMA.$emit('DATA_OK', res.data.message)
      //     this.showAsmuo = false
      //     this.modalAsmuoKey = 'asmuo'
      //     this.getData()
      //   })
      //   .catch(err => {
      //     window._VMA.$emit('DATA_ERROR', err.response.data.message)
      //   })
      //   .finally(() => {
      //     this.loading = false
      //   })
    },
    deleteAtstovas(item) {
      this.modalDeleteVardas = item.asm_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.modalDeleteRole = 'atstovas'
      this.showDelete = true
    },
    openInformavimas(item) {
      this.modalInformavimasKey =
        'informavimas' + this.modalInformavimasRefresh++
      this.modalInformavimasReadonly = item && !item.canEdit
      this.modalInformavimasItem = item
        ? JSON.parse(JSON.stringify(item))
        : { asm_pavadinimas: '', sasm_el_pastai: [''] }
      this.showInformavimas = true
    },
    confirmInformavimas() {
      this.getData()
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.asm_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.modalDeleteRole = this.asmuoRole
      this.showDelete = true
    },
    confirmDelete(item) {
      if (this.modalDeleteRole === 'atstovas') {
        this.confirmDeleteAtstovas(item)
      } else {
        this.confirmDeleteAsmuo(item)
      }
    },
    confirmDeleteAsmuo(item) {
      this.loading = true

      this.$axios
        .delete(`asmuo/${item.sasm_id}/${this.modalDeleteRole}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmDeleteAtstovas(item) {
      this.loading = true

      this.$axios
        .delete(`asmuo/${item.parent_atstovas_id}/atstovas`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changePageidavimas(item) {
      this.loading = true

      item.sasm_atpirkimo_pageidavimas = !item.sasm_atpirkimo_pageidavimas
      const data = {
        sasm_id: item.sasm_id,
        sasm_atpirkimo_pageidavimas: item.sasm_atpirkimo_pageidavimas,
      }

      this.$axios
        .post(`asmuo/${item.sasm_id}/${this.asmuoRole}/pageidavimas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)

          //this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    restoreItem(item) {
      this.$axios
        .post(`asmuo/${item.sasm_id}/${item.sasm_role_objekte}/restore`)
        .then(res => {
          this.getData()
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    getActiveClass(item) {
      return ''
    },
    withTeiseDalis(value) {
      let checkOn = value.filter(x => !this.turtasDavejas.includes(x))
      let checkOff = this.turtasDavejas.filter(x => !value.includes(x))
      if (checkOn.length > 0) {
        let add = this.getAsmenysSameDalis(checkOn[0], true)
        value.push(...add)
      }
      if (checkOff.length > 0) {
        let remove = this.getAsmenysSameDalis(checkOff[0], false)
        remove.forEach(item => {
          value.splice(value.indexOf(item), 1)
        })
      }
      return value
    },
    getAsmenysSameDalis(sasmID, add) {
      if (!this.isNtr) {
        return []
      }
      let dalis = this.asmenys.find(item => item.sasm_id === sasmID)
        .ntr_dalis_id
      let filteredAsmenys = this.asmenys.filter(item => {
        return item.ntr_dalis_id === dalis
      })

      let asmenysPavadinimas = filteredAsmenys
        .map(item => item.asm_pavadinimas)
        .join(', ')
      window._VMA.$emit(
        'DATA_OK',
        `Kartu ${
          add ? 'pažymimi' : 'nužymimi'
        } visi šios turto dalies savininkai: \n ${asmenysPavadinimas}`
      )

      return this.asmenys
        .filter(item => {
          return item.ntr_dalis_id === dalis
        })
        .map(item => item.sasm_id)
    },
    updateAsmuoSelect(pazymetasList) {
      if (this.showSavitarnaCopySkolininkai) {
        this.copySavitarnaSkolininkai(pazymetasList)
      }
      if (this.showSavitarnaCopyIkaitoDavejai) {
        this.copySavitarnaDavejai(pazymetasList)
      }
      if (this.showSavitarnaCopyKreditoriai) {
        this.copySavitarnaKreditoriai(pazymetasList)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.foreign-pastaba {
  color: #e4800d;
  font-size: 0.75rem;
}
</style>
